import * as Crypto from 'expo-crypto';
import {Box, Button, Column} from 'native-base';
import React, {useMemo} from 'react';
import BottomSheetScrollView from '@ui/components/gorhom/BottomSheetScrollView';
import FloatingLabelInput from '@ui/components/FloatingLabelInput';
import SelectAvatarButton from '@ui/components/SelectAvatarButton';
import SelectedPlayersRow from './SelectedPlayersRow';
import {useCreateTeam} from '@ui/provider/CreateTeamProvider';
import useTrackButtonClick from '@ui/helpers/analytics/analytics-hooks';
import {useTranslation} from 'react-i18next';

interface Props {
    onTeamCreated: (teamId: string) => void;
    isLoading?: boolean;
}

export const TeamCreate = (props: Props) => {
    const {onTeamCreated, isLoading} = props;
    const {imagePickerResult, clearData, players, removePlayer, setImagePickerResult, isButtonDisabled, teamName, setTeamName, createTeam, isCreateTeamLoading} = useCreateTeam();
    const {t} = useTranslation();
    const id = useMemo(() => Crypto.randomUUID(), []);
    const trackButtonClick = useTrackButtonClick();

    const onPress = async() => {
        const teamId = await createTeam(id);

        if(!teamId){
            return;
        }

        clearData();
        onTeamCreated(teamId);
    };

    return (
        <Column flex={1} p={4} safeAreaBottom>
            <BottomSheetScrollView showsVerticalScrollIndicator={false} style={style}>
                <Column flex={1} w='full'>
                    <Box pb='4'>
                        <SelectAvatarButton imagePickerResult={imagePickerResult} setImagePickerResult={setImagePickerResult} />
                    </Box>

                    <FloatingLabelInput label={t('team.create.teamName')} defaultValue={teamName} onChangeText={setTeamName} autoFocus maxLength={60} />

                    <Box h='3'/>

                    <SelectedPlayersRow p='0' players={players} removePlayer={removePlayer}/>
                </Column>
            </BottomSheetScrollView>

            <Button
                isDisabled={isButtonDisabled}
                onPress={trackButtonClick('Team Created', {team_id: id}, onPress)}
                isLoading={isCreateTeamLoading || isLoading}
            >
                {t('team.create.create')}
            </Button>
        </Column>
    );
};

const style = {flex: 1};
